import React from "react";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading";

import { api } from "../../Services/Api";

import { Container, Form, ChoosedPlan } from "./styles";

function Checkout() {
  const history = useHistory();
  const user = useSelector((state) => state.user.userData);
  const { name: storeName, id: storeId } = useSelector((state) => state.store);

  const mutation = useMutation("subscriptions", (values) => {
    return api.post(`/bff-portal/subscribe`, values);
  });

  const formik = useFormik({
    initialValues: {
      planId: "29458c46-4af1-4b9e-ab50-88da389b97b8",
      subscriberPhone: user.phone,
      subscriberEmail: user.email,
      storeName: storeName,
      subscriberName: user.name,
    },
    onSubmit: (values, actions) => {
      mutation.mutateAsync(values).then((res) => {
        toast.success("Assinatura realizada com sucesso");
        history.replace("/");
      });
    },
  });

  return (
    <Container className="main-section-content">
      <div>
        <Form onSubmit={formik.handleSubmit}>
          <FormControl component="fieldset">
            <FormLabel component="legend">CPF/CNPJ:</FormLabel>
            <TextField
              size="small"
              placeholder="023.234.122-23"
              variant="outlined"
              name="subscriberDocument"
              value={formik.values.subscriberDocument}
              onChange={formik.handleChange}
            />
          </FormControl>
          <FormControl component="fieldset">
            <FormLabel component="legend">Endereço:</FormLabel>

            <Grid container spacing={1}>
              <Grid sm={12} item>
                <Grid item sm={3} xs={4}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="CEP"
                    label="CEP"
                    name="addressCep"
                    value={formik.values.addresCep}
                    onChange={formik.handleChange}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Rua"
                  label="Rua"
                  name="addressStreet"
                  variant="outlined"
                  value={formik.values.addressStreet}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Bairro"
                  label="Bairro"
                  value={formik.values.addressNeighborhood}
                  onChange={formik.handleChange}
                  name="addressNeighborhood"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Numero"
                  name="addressNumber"
                  label="Numero"
                  value={formik.values.addressNumber}
                  onChange={formik.handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Cidade"
                  label="Cidade"
                  name="addressCity"
                  variant="outlined"
                  value={formik.values.addressCity}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  fullWidth
                  size="small"
                  name="addressState"
                  placeholder="Estado"
                  label="Estado"
                  variant="outlined"
                  value={formik.values.addressState}
                  onChange={formik.handleChange}
                />
              </Grid>
            </Grid>
          </FormControl>
          <Button
            type="submit"
            color="primary"
            size="large"
            variant="contained"
          >
            Assinar agora
          </Button>
          {mutation.isLoading && <Loading />}
        </Form>
      </div>
      <div className="flex-columns align-center"></div>
    </Container>
  );
}

export default Checkout;
